import React, { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RANGES = [["today", "Today"], ["week", "7 din"], ["month", "30 din"], ["all", "All time"]];

function Stat({ label, value, cls = "text-white", testid }) {
  return (
    <div className="surface p-4" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500">{label}</div>
      <div className={`font-mono text-2xl sm:text-3xl mt-1 ${cls}`}>{value}</div>
    </div>
  );
}

export function VipResults() {
  const [data, setData] = useState(null);
  const [range, setRange] = useState("month");
  useEffect(() => {
    axios.get(`${API}/public/trades`).then(({ data }) => {
      setData(data);
      if (!data.ranges.month.count) setRange(RANGES.find(([k]) => data.ranges[k].count)?.[0] || "month");
    }).catch(() => {});
  }, []);
  if (!data) return null;
  const tabs = RANGES.filter(([k]) => data.ranges[k].count > 0);
  if (!tabs.length) return null;
  const r = data.ranges[range];
  const pips = `${r.net_pips >= 0 ? "+" : ""}${r.net_pips}`;
  return (
    <section className="max-w-6xl mx-auto px-5 pt-14" data-testid="vip-results">
      <div className="flex flex-wrap items-end gap-3 mb-5">
        <h2 className="font-head text-white text-base md:text-lg uppercase tracking-widest">VIP results</h2>
        <div className="ml-auto flex gap-1" data-testid="vip-results-tabs">
          {tabs.map(([k, l]) => (
            <button key={k} onClick={() => setRange(k)} data-testid={`vip-range-${k}`}
              className={`px-3 py-1.5 text-xs border transition-colors duration-200 ${range === k ? "border-gold text-gold" : "border-[color:var(--border-subtle)] text-slate-400 hover:text-white"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Win rate" value={`${r.win_rate}%`} cls="text-gold" testid="vip-stat-winrate" />
        <Stat label="Net pips" value={pips} cls={r.net_pips >= 0 ? "text-bull" : "text-bear"} testid="vip-stat-pips" />
        <Stat label="Wins" value={r.wins} cls="text-bull" testid="vip-stat-wins" />
        <Stat label="Losses" value={r.losses} cls="text-bear" testid="vip-stat-losses" />
      </div>
      <div className="surface mt-3 divide-y divide-[color:var(--border-subtle)]" data-testid="vip-results-list">
        {r.trades.slice(0, 10).map((t) => (
          <div key={t.id} className="px-4 py-3 flex items-center gap-3 text-sm" data-testid={`vip-trade-${t.id}`}>
            <span>{t.icon}</span>
            <span className="text-white">{t.instrument}</span>
            <span className={`text-xs ${String(t.direction).toLowerCase() === "buy" ? "text-bull" : "text-bear"}`}>{t.direction}</span>
            <span className="text-[11px] text-slate-500 hidden sm:inline">{t.closed_date}</span>
            <span className={`ml-auto font-mono ${t.net_pips >= 0 ? "text-bull" : "text-bear"}`}>{t.net_pips >= 0 ? "+" : ""}{t.net_pips} pips</span>
            {t.outcome === "win" ? <CheckCircle2 size={16} className="text-bull" /> : <XCircle size={16} className="text-bear" />}
          </div>
        ))}
      </div>
      <a href="/results" className="inline-block mt-3 text-xs text-gold hover:underline" data-testid="vip-results-all">Saare results dekhein →</a>
    </section>
  );
}
